// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import CustomerFormController from "./customer_form_controller";
import FileUploadController from "./file_upload_controller";
import DocumentTemplatesController from "./document_templates_controller";
import AddressesController from "./addresses_controller";
import ChatController from "./chat_controller";
import TurboSelectController from "./turbo_select_controller";
import CalendarPopoverController from "./calendar_popover_controller";
import CalendarDurationController from "./calendar_duration_controller";
import LawsuitFormController from "./lawsuit_form_controller";
import AutoRefreshController from "./auto_refresh_controller";
import ParticipantsDropdownController from "./participants_dropdown_controller";
import FlashMessageController from "./flash_message_controller";

application.register("customer-form", CustomerFormController);
application.register("file_upload", FileUploadController);
application.register("document_templates", DocumentTemplatesController);
application.register("addresses", AddressesController);
application.register("chat", ChatController);
application.register("turbo-select", TurboSelectController);
application.register("calendar-popover", CalendarPopoverController);
application.register("calendar-duration", CalendarDurationController);
application.register("participants-dropdown", ParticipantsDropdownController);
application.register("lawsuit-form", LawsuitFormController);
application.register("auto-refresh", AutoRefreshController);
application.register("flash-message", FlashMessageController);
